import { Container } from "@mui/material";
import "./App.css";
import MainRouter from "./main/router/MainRouter";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { MainContext } from "./main/context/MainContextProvider";
import { useContext } from "react";
import { RopV2AppNativeProvider } from "./modules/ropv2app/context/RopV2AppNativeContext";
import { NotificationBackdrop } from "./modules/notifications/components/NotificationBackdrop";


function App() {
  const { theme } = useContext(MainContext);

  return (
    <RopV2AppNativeProvider>
      <ThemeProvider theme={theme.muiTheme}>
        <CssBaseline />
        <Container
          style={{
            height: "100vh",
            overflowY: "auto",
            padding: 0,
            backgroundColor: theme.backgroundScreenColor,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          maxWidth={false}
        >
          <NotificationBackdrop />
          <MainRouter />
        </Container>
      </ThemeProvider>
    </RopV2AppNativeProvider>
  );
}

export default App;
